<nb-card class="dialog">
  <nb-card-header class="header">
    <morva-icons
      class="close-cross"
      icon="close"
      (click)="closeDialog()"
    ></morva-icons>
    <p data-testid="webservice-create-header-text" class="header-text">Web Service</p>
  </nb-card-header>

  <nb-card-body class="body">
    <form
      [formGroup]="webServiceForm"
      class="form row g-3"
    >
      <!-- row 0: name -->
      <div class="rowContainer col-12">
        <div class="col-2">
          <label for="name" class="label">نام</label>
        </div>
        <div class="col-10">
          <input
            nbInput
            type="text"
            class="input form-control"
            id="name"
            formControlName="name"
          />
        </div>
      </div>

      <!-- row 1: address -->
      <div class="rowContainer col-12">
        <div class="col-2">
          <label for="address" class="label">آدرس (url)</label>
        </div>
        <div class="col-10">
          <input
            nbInput
            type="text"
            class="input form-control"
            id="address"
            formControlName="address"
          />
        </div>
      </div>

      <!-- row 2: dataType -->
      <div class="rowContainer col-12">
        <div class="col-2">
          <label for="dataType" class="label">نوع</label>
        </div>
        <div class="col-10">
          <ng-select
            [items]="dataTypes"
            [searchable]="false"
            bindLabel="name"
            bindValue="name"
            labelForId="dataType"
            formControlName="dataType"
          >
          </ng-select>
        </div>
      </div>

      <!-- row 3: methodType -->
      <div class="rowContainer col-12">
        <div class="col-2">
          <label for="methodType" class="label">متد</label>
        </div>
        <div class="col-10">
          <ng-select
            [items]="methodTypes"
            [searchable]="false"
            bindLabel="name"
            bindValue="name"
            labelForId="methodType"
            formControlName="methodType"
          >
          </ng-select>
        </div>
      </div>

      <!-- row 4: columns -->
      <div class="rowContainer col-12 justify-content-center">
        <div class="col-4">
          <label for="authenticationType" class="label ps-3">نام</label>
        </div>
        <div class="col-4">
          <label for="authenticationType" class="label ps-3 pe-1">مقدار</label>
        </div>
      </div>

      <div *ngFor="let parameter of requestParameters;let indexParam=index" class="rowContainer col-12 mt-1">
        <div class="col-2">
          <label class="label">پارامتر</label>
        </div>
        <div class="col-4 ps-3">
          <input
            nbInput
            type="text"
            class="input"
            [(ngModel)]="parameter.name"
            [ngModelOptions]="{standalone: true}"
            (ngModelChange)="validatorRequestParameters()"
          />
        </div>
        <div class="col-4 ps-3">
          <input
            nbInput
            type="text"
            class="input"
            [(ngModel)]="parameter.value"
            [ngModelOptions]="{standalone: true}"
            (ngModelChange)="validatorRequestParameters()"
          />
        </div>
        <div class="col-1" *ngIf="indexParam === 0">
          <label class="label blue" (click)="addParameter()">اضافه</label>
        </div>
        <div class="col-1">
          <label class="label blue" *ngIf="indexParam !== 0" (click)="removeParameter(parameter)">حذف</label>
        </div>
      </div>

      <!-- row 5: columns -->
      <div class="rowContainer col-12 justify-content-center">
        <div class="col-4">
          <label for="authenticationType" class="label ps-3">نام</label>
        </div>
        <div class="col-4">
          <label for="authenticationType" class="label ps-3 pe-1">مقدار</label>
        </div>
      </div>

      <div *ngFor="let header of requestHeaders;let indexParam=index" class="rowContainer col-12 mt-1">
        <div class="col-2">
          <label class="label">هدر</label>
        </div>
        <div class="col-4 ps-3">
          <input
            nbInput
            type="text"
            class="input"
            [(ngModel)]="header.name"
            [ngModelOptions]="{standalone: true}"
            (ngModelChange)="validatorRequestHeaders()"
          />
        </div>
        <div class="col-4 ps-3">
          <input
            nbInput
            type="text"
            class="input"
            [(ngModel)]="header.value"
            [ngModelOptions]="{standalone: true}"
            (ngModelChange)="validatorRequestHeaders()"
          />
        </div>
        <div class="col-1" *ngIf="indexParam === 0">
          <label class="label blue" (click)="addHeader()">اضافه</label>
        </div>
        <div class="col-1">
          <label class="label blue" *ngIf="indexParam !== 0" (click)="removeHeader(header)">حذف</label>
        </div>
      </div>
      <!-- row 5: columns -->
      <div class="rowContainer col-12 justify-content-center">
        <div class="col-4">
          <label for="authenticationType" class="label ps-3">نام</label>
        </div>
        <div class="col-4">
          <label for="authenticationType" class="label ps-3 pe-1">مقدار</label>
        </div>
      </div>

      <div *ngFor="let body of jsonBody;let indexParam=index" class="rowContainer col-12 mt-1">
        <div class="col-2">
          <label class="label">بادی</label>
        </div>
        <div class="col-4 ps-3">
          <input
            nbInput
            type="text"
            class="input"
            [(ngModel)]="body.name"
            [ngModelOptions]="{standalone: true}"
            (ngModelChange)="validatorRequestBodies()"
          />
        </div>
        <div class="col-4 ps-3">
          <input
            nbInput
            type="text"
            class="input"
            [(ngModel)]="body.value"
            [ngModelOptions]="{standalone: true}"
            (ngModelChange)="validatorRequestBodies()"
          />
        </div>
        <div class="col-1" *ngIf="indexParam === 0">
          <label class="label blue" (click)="addBody()">اضافه</label>
        </div>
        <div class="col-1">
          <label class="label blue" *ngIf="indexParam !== 0" (click)="removeBody(body)">حذف</label>
        </div>
      </div>
      <!-- row 6: authenticationType -->
      <div class="rowContainer col-12">
        <div class="col-2">
          <label for="authenticationType" class="label">احراز هویت</label>
        </div>
        <div class="col-10">
          <ng-select
            [items]="authenticationTypes"
            [searchable]="false"
            bindLabel="name"
            bindValue="name"
            appendTo="body"
            labelForId="authenticationType"
            formControlName="authenticationType"
            (change)="changeAuthenticationTypes($event)"
          >
          </ng-select>
        </div>
      </div>

      <!-- row 7: username -->
      <div class="rowContainer col-12" *ngIf="webServiceForm.value.authenticationType === 'Basic Authentication'">
        <div class="col-2">
          <label for="username" class="label">نام کاربری</label>
        </div>
        <div class="col-10">
          <input
            nbInput
            type="text"
            class="input form-control"
            id="username"
            formControlName="username"
          />
        </div>
      </div>

      <!-- row 8: password -->
      <div class="rowContainer col-12" *ngIf="webServiceForm.value.authenticationType === 'Basic Authentication'">
        <div class="col-2">
          <label for="password" class="label">رمز عبور</label>
        </div>
        <div class="col-10">
          <input
            nbInput
            autocomplete="new-password"
            type="password"
            class="input form-control"
            id="password"
            formControlName="password"
          />
        </div>
      </div>
    </form>
  </nb-card-body>
      <!-- row 9: submit button  -->
      <div class="sticky">
        <div class="d-flex flex-row-reverse ">
          <button
            nbButton
            type="submit"
            [ngClass]="!(webServiceForm.invalid && !validParameters) ? 'active' : 'disabled'"
            [disabled]="webServiceForm.invalid && !validParameters"
            [nbSpinner]="submitting"
            (click)="submit()"
          >
            ذخیره
          </button>
        </div>
      </div>

</nb-card>
